import React, { Component } from "react";
import MediaQuery from "react-responsive";
import Carousel from "./../components/Slider";
import CarouselMobile from "./../components/SliderMobile";
import CarouselTrending from "./../components/SliderTrending";
import Layout from "./../layouts/Main";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getRecentMoqs } from "./../store/actions/MoqActions";
import { getCategories } from "./../store/actions/CategoryActions";
import { getRecentSearches } from "./../store/actions/RecentSearchActions";
import CategoryMOQsCard from "./../components/CategoryMOQsCard";
import ContentLoader from "react-content-loader";
import instance from "../utils/instance";
import { Helmet } from "react-helmet-async";
import { LazyLoadImage } from "react-lazy-load-image-component";

const BlockLoader = ({ height = 300, radius = 8, uniqueKey = "unique" }) => (
  <ContentLoader
    uniqueKey={uniqueKey}
    speed={2}
    width={`100%`}
    height={height}
    backgroundColor="#ECEBEB"
    foregroundColor="#b0b0b0"
  >
    <rect x="0" y="0" rx={`${radius}`} ry={`${radius}`} width="100%" height={`${height}`} />
  </ContentLoader>
);

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading_moqs: true,
      loading_searches: true,
      loading_promotions: true,
      loading_trending: true,
      categories_loading: true,
      promotions: [],
      trending: [],
    };
  }

  componentDidMount = async () => {
    this.fetchCategories();

    try {
      await this.props.getRecentMoqs();
      this.setState({ loading_moqs: false });
    } catch (e) {
      console.error("Failed to load recent moqs", e);
    }

    try {
      await this.getTrending();
      this.setState({ loading_trending: false });
    } catch (e) {
      console.error("Failed to load trending moqs", e);
    }

    if (window.innerWidth >= 768) {
      await this.getPromotions();
    } else {
      this.setState({ loading_promotions: false });
    }

  };

  getPromotions = async () => {
    try {
      const result = await instance.get("home_promotions");
      if (result?.data?.promotions) {
        this.setState({ promotions: result.data.promotions, loading_promotions: false });
      }
    } catch (e) {
      console.error("Failed to load promotions", e);
    }
  };

  getTrending = async () => {
    try {
      const result = await instance.get("moq/trending");
      if (result?.data?.moqs) {
        this.setState({ trending: result.data.moqs, loading_trending: false });
      }
    } catch (e) {
      console.error("Failed to load trending", e);
    }
  };

  fetchCategories = async () => {
    try {
      this.setState({ categories_loading: true });
      await this.props.getCategories();
      this.setState({ categories_loading: false });
    } catch (e) {
      console.error("Failed to load categories", e);
      this.setState({ categories_loading: false });
    }
  };

  render() {
    const {
      categories: { data },
      moqs: { recent_moqs },
    } = this.props;

    const {
      loading_moqs,
      loading_promotions,
      loading_trending,
      categories_loading,
      promotions,
      trending,
    } = this.state;

    return (
      <Layout>
        <Helmet prioritizeSeoTags>
          <meta charSet="utf-8" />
          <title>{`Litudian | Kenya's Top Sourcing Platform`}</title>
          <link rel="icon" href="/favicon.ico" />
        </Helmet>

        <div className="grid grid-cols-1 md:grid-cols-4 md:gap-4 py-1">
          {/* Recent Campaigns */}
          <div className="flex flex-col mb-8 md:mb-0">
            <h1 className="text-[#A68F69] dark:text-tangerine font-bold uppercase">
              New Campaigns
            </h1>

            {loading_moqs ? (
              <div className="flex flex-col space-y-2 mt-1">
                <BlockLoader height={64}/>
                <BlockLoader height={64} />
                <BlockLoader height={64} />
                <BlockLoader height={64} />
                <BlockLoader height={64} />
              </div>
            ) : (
              
              recent_moqs.map((moq, i) => (
                <div key={moq?.moq_slug} className="bg-[#ECEBEB] dark:bg-[#5B5B5B] w-full h-16 mt-2 shadow flex items-center px-2">
                  {/* Left section - Image + Text */}
                  <div className="flex items-center space-x-2 flex-shrink-0">
                    <LazyLoadImage
                      className="w-12 h-12"
                      src={
                        moq?.product?.length && moq?.product[0]?.images.length
                          ? moq?.product[0]?.images[0]
                          : "https://via.placeholder.com/300"
                      }
                      alt={moq?.product_name?.toLowerCase()}
                    />
                    <p className="font-bold capitalize text-sm text-gray-500 dark:text-white truncate max-w-[162px]">
                      <span>{moq?.product[0]?.name?.toLowerCase()}</span>
                      <br />
                      <span>KES {moq?.readable_moq_price}</span>
                    </p>
                  </div>

                  {/* Right section - Buy Now button */}
                  <button
                    className="bg-tangerine text-white text-sm px-2 py-2 ml-auto cursor-pointer"
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = `/products/${moq?.moq_slug || moq?.id}`;
                    }}
                  >
                    Buy Now
                  </button>
                </div>
              ))
            )}
          </div>

          {/* Carousel Section For Hero Slider*/}
          <div className="col-span-2">

            <MediaQuery minWidth={768}>
              {loading_promotions ? (
                <BlockLoader uniqueKey="carousel" height={380} width="100%" />
              ) : (
                <Carousel promotions={promotions} />
              )
            }
            </MediaQuery>
            {/* Trending on Mobile*/}
            <MediaQuery maxWidth={767}>
              <h1 className="text-[#A68F69] dark:text-tangerine font-bold uppercase mb-1">
                Trending Now 🔥
              </h1>
              {loading_trending ? (
                <BlockLoader uniqueKey="carousel" height={350} width="100%" />
              ) : (
                <CarouselMobile trending={trending} />
              )
            }
            </MediaQuery>
          </div>

          {/* Trending on Desktop */}
          <div className="hidden md:flex flex-col">
            <h1 className="text-[#A68F69] dark:text-tangerine font-bold uppercase">
              Trending Now 🔥
            </h1>

            {loading_trending ? (
              <div className="flex flex-col space-y-2 mt-1">
                <BlockLoader uniqueKey="carousel" height={352} />
              </div>
            ) : (
              <CarouselTrending trending={trending} />
            )}
          </div>
        </div>

        {/* Categories */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-1">
          {categories_loading ? (
            <>
              <BlockLoader uniqueKey="cat1" height={350} radius={6} />
              <BlockLoader uniqueKey="cat2" height={350} radius={6} />
              <BlockLoader uniqueKey="cat3" height={350} radius={6} />
              <BlockLoader uniqueKey="cat4" height={350} radius={6} />
            </>
          ) : (
            data.map((category, i) => <CategoryMOQsCard key={i} category={category} />)
          )}
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  categories: state.categories,
  recent_searches: state.recent_searches,
  moqs: state.moqs,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { getCategories, getRecentSearches, getRecentMoqs },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Index);
